import React, { Component } from 'react';
import { navigateTo } from 'gatsby-link';
import CLink from './cLink';
import Logo from '../assets/img/logo.svg';

const links = [
  {
    name: 'kontakt',
    id: 'contact',
    className: 'contact-link btn btn-primary btn-filled',
  },
  {
    name: 'o nas',
    id: 'aboutUs',
  },
  {
    name: 'oferta',
    id: 'offer',
  },
  {
    name: 'opinie klientów',
    id: 'testimonials',
  },
  {
    name: 'co to jest rodo?',
    id: 'aboutRodo',
  },
];

export default class Navbar extends Component {
  state = { sideBarClass: 'offscreen-container' };

  smoothScroll = id => {
    const target = document.querySelector(`#${id}`);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    } else {
      navigateTo('/');
    }
    if (id !== 'main') {
      this.handleSideBar();
    }
  };

  handleSideBar = () => {
    const icon = document.getElementById('menu-icon');
    icon.classList.toggle('change');

    this.setState(prevState => {
      if (prevState.sideBarClass.includes('reveal-nav')) {
        return { sideBarClass: 'offscreen-container' };
      }
      return { sideBarClass: 'offscreen-container reveal-nav' };
    });
  };

  render() {
    return (
      <div className="nav-container">
        <nav className="top-bar overlay-bar nav-sticky">
          <div className="container">
            <div className="row nav-menu">
              <div className="col-sm-1 col-md-2 columns">
                <CLink id="main" onClick={this.smoothScroll} style={{ display: 'inline-block' }}>
                  <img className="logo logo-dark" alt="Logo" src={Logo} />
                </CLink>
                <div className="menu-icon" id="menu-icon" onClick={this.handleSideBar}>
                  <div className="div-1" />
                  <div className="div-2" />
                  <div className="div-3" />
                </div>
              </div>

              <div className="col-sm-11 col-md-10 columns">
                <ul className="menu main-menu">
                  {links.map(item => (
                    <li key={item.id}>
                      <CLink className={item.className ? item.className : ''} id={item.id} onClick={this.smoothScroll}>
                        {item.name}
                      </CLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className={this.state.sideBarClass}>
              <ul className="menu side-menu">
                {links.map(item => (
                  <li key={item.id}>
                    <CLink id={item.id} onClick={this.smoothScroll}>
                      {item.name}
                    </CLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Nav.js